// extracted by mini-css-extract-plugin
export var active = "tag-module--active--o6cKl";
export var canHover = "tag-module--can-hover--WXiZD";
export var small = "tag-module--small--qy3lC";
export var tagBox = "tag-module--tag-box--enEUs";